import React from 'react'
import {useNavigate} from "react-router-dom";
import {Row, Col, Button} from 'react-bootstrap';
import styles from './resource-not-found.module.scss';

const ResourceNotFound = () => {
  const navigate = useNavigate();
  const returnToDashboard = () => navigate('/');

  return (
    <div className={styles['panel']}>
      <Row>
        <Col xs={12} lg={6}>
          <Row>
            <Col lg={12}>
              <div className={styles['error-message']}>
                Oops, resource not found!
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Button onClick={()=>returnToDashboard()}>
                RETURN TO DASHBOARD
              </Button>
            </Col>
          </Row>
        </Col>
        <Col xs={12} lg={6}>
          <Row>
            <Col lg={12}>
              <div className={styles['error-code']}>
                404
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default ResourceNotFound;
